export default __webpack_public_path__ + "static/media/Vector.70362c5f.png";